import { get, isEmpty } from 'lodash/fp';

import { HowTo, UrlObject } from '../../types/__codegen__/sanity/graphql';
import HowItWorksSection from '../sections/how-it-works-section';
import mapStepsContent from './map-steps-content';

type HowItWorksProps = {
  howTo:
    | HowTo
    | {
        slogan: {}[];
        steps: {
          description: {}[];
          imageObject: {};
          name: string;
          urlObject?: UrlObject;
        }[];
      };
};

const HowItWorks = ({ howTo }: HowItWorksProps) => {
  const steps = get('steps', howTo);
  if (isEmpty(steps)) {
    return null;
  }

  const urlObject = get('urlObject', howTo);
  const cta = urlObject
    ? { importance: get('importance', howTo), name: get('name', urlObject), url: get('url', urlObject) }
    : undefined;
  const mappedSteps = mapStepsContent(steps);
  return <HowItWorksSection cta={cta} title={get('slogan', howTo)} steps={mappedSteps} />;
};

export default HowItWorks;
